import { useMutation, useQueryClient } from 'react-query';
import { communicationKeys } from '../cache-keys/communicationKeys';
import { useAPI } from '@axo/shared/data-access/provider';
import { comment_api } from '@axo/shared/data-access/api';

export function useResolveComment(applicationID: string) {
  const api = useAPI();
  const client = useQueryClient();

  return useMutation(comment_api.resolveComment(api), {
    onSuccess: () => {
      return client.invalidateQueries(
        communicationKeys.comments({ applicationID })
      );
    },
  });
}
